import { Reveal } from "@/components/site/Reveal";

export const SectionHead = ({ num, eyebrow, title, lede, id }) => (
  <Reveal>
    <div className="eyebrow" id={id ? undefined : undefined}>
      <span className="eyebrow-num">{num}</span>
      <span>{eyebrow}</span>
    </div>
    <h2 className="section-h2">{title}</h2>
    {lede && <p className="section-lede">{lede}</p>}
  </Reveal>
);
